// extracted by mini-css-extract-plugin
module.exports = {"title":"RatingInfo_title__XPD8E","rating":"RatingInfo_rating__6HGtL"};